import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import MuiTabs from '@mui/material/Tabs';
import { styled } from '@mui/material/styles';

export const TabsRoot = styled(Box)(({ theme }) => ({
  background: 'none',
  borderRadius: theme.spacing(0.5),
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  maxHeight: '100%',
}));

export const TabsList = styled(MuiTabs)({});

export const TabStyled = styled(Tab)(({ theme }) => ({
  fontSize: theme.typography['body-small'].fontSize,
  textTransform: 'capitalize',
}));

export const TabBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'overflow',
})<{ overflow?: string }>(({ overflow = 'auto' }) => ({
  display: 'flex',
  flexGrow: 1,
  flexDirection: 'column',
  overflow,
}));
